import { ProductReference } from "@commercetools/platform-sdk";
import { COMMERCETOOLS_ATTRIBUTES } from "@Libs/commercetools/contants";
import { IProductSetItem } from "@Types/product-details";
import { IProductAttributes } from "@Types/promo-carousel/product-tile";
import { isCanadianLocale } from "@Utils/locale";

export const getPrepTips = (attribs: any[], currentLocale: string) => {
  if (isCanadianLocale(currentLocale)) {
    const prepTipsIndex = attribs?.findIndex(
      (el: IProductAttributes) => el.name === "prepTips"
    );

    return prepTipsIndex > -1 && attribs[prepTipsIndex]?.value
      ? attribs[prepTipsIndex]?.value[currentLocale]
      : "";
  }
};

export const getCountryOfOrigin = (attribs: any[]) => {
  const countryOfOriginIndex = attribs?.findIndex(
    (el: IProductAttributes) => el.name === "countryOfOrigin"
  );

  return countryOfOriginIndex > -1 && attribs[countryOfOriginIndex]?.value
    ? attribs[countryOfOriginIndex]?.value
    : "";
};

export const getIngredients = (attribs: any[], currentLocale: string) => {
  if (isCanadianLocale(currentLocale)) {
    const ingredientsIndex = attribs?.findIndex(
      (el: IProductAttributes) => el.name === "ingredients"
    );

    return ingredientsIndex > -1 && attribs[ingredientsIndex]?.value
      ? attribs[ingredientsIndex]?.value[currentLocale]
      : "";
  }
};

const getSetItemProductQuantity = (attribs?: IProductAttributes[]) =>
  attribs?.find(
    (el) => el.name === COMMERCETOOLS_ATTRIBUTES.PRODUCT_SET_LINE_QUANTITY
  )?.value;

export const getSetItemProducts = (
  attribs: IProductAttributes[]
): IProductSetItem[] | undefined => {
  const setItemProducts = attribs?.find(
    (el: IProductAttributes) => el.name === COMMERCETOOLS_ATTRIBUTES.SET_ITEMS
  )?.value;
  return setItemProducts?.map((setItemProduct: ProductReference) => {
    const referencedProduct = setItemProduct?.obj;
    const referencedProductAttributes =
      referencedProduct?.masterData?.current?.masterVariant?.attributes;
    const lineQuantity = getSetItemProductQuantity(referencedProductAttributes);

    const { slug, name } = referencedProduct?.masterData?.current || {};
    const lang = "en-CA";

    return {
      slug: slug?.[lang] || "",
      name: name?.[lang] || "",
      lineQuantity,
    };
  });
};
